import ApiService from './api';

// Authentication API service
class AuthService {
  // Agent login
  static async login(credentials) {
    try {
      const response = await ApiService.post('/auth/login', {
        ...credentials,
        role: 'agent' // Ensure agent login
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Agent registration
  static async register(userData) {
    try {
      const response = await ApiService.post('/auth/register', {
        ...userData,
        role: 'agent', // Set role as agent
        sellerType: 'individual', // Default sellerType for agents
        portal: 'agent-dashboard',
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Registration OTP
  static async sendRegistrationOtp(email) {
    try {
      const response = await ApiService.post('/auth/register/otp/send', {
        email,
        role: 'agent',
        portal: 'agent-dashboard',
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Agent logout
  static async logout() {
    try {
      const response = await ApiService.post('/auth/logout');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get current agent profile
  static async getProfile() {
    try {
      const response = await ApiService.get('/auth/profile');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Update agent profile
  static async updateProfile(data) {
    try {
      const response = await ApiService.put('/auth/profile', data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Change password
  static async changePassword(data) {
    try {
      const response = await ApiService.put('/auth/change-password', data);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Forgot password
  static async sendForgotPasswordOtp(email) {
    try {
      const response = await ApiService.post('/auth/forgot-password/otp/send', {
        email,
        portal: 'agent-dashboard',
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Verify OTP
  static async verifyForgotPasswordOtp(email, otp) {
    try {
      const response = await ApiService.post('/auth/forgot-password/otp/verify', {
        email,
        otp,
        portal: 'agent-dashboard',
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Reset password with OTP
  static async resetPasswordWithOtp({ email, otp, password, confirmPassword }) {
    try {
      const response = await ApiService.post('/auth/forgot-password/otp/reset', {
        email,
        otp,
        portal: 'agent-dashboard',
        password,
        confirmPassword,
      });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Backward compatibility wrappers
  static async forgotPassword(email) {
    return this.sendForgotPasswordOtp(email);
  }

  static async resetPassword(payload, password) {
    if (typeof payload === 'object') {
      return this.resetPasswordWithOtp(payload);
    }

    throw new Error('Use resetPasswordWithOtp({ email, otp, password, confirmPassword }) for OTP flow.');
  }

  // Refresh token
  static async refreshToken() {
    try {
      const response = await ApiService.post('/auth/refresh-token');
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default AuthService;